import React from 'react';
import { FaTimes } from 'react-icons/fa';

interface CloseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ 
  size = 'md', 
  className = '',
  ...props 
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'w-6 h-6 p-1';
      case 'md':
        return 'w-8 h-8 p-1.5';
      case 'lg':
        return 'w-10 h-10 p-2';
      default:
        return 'w-8 h-8 p-1.5';
    }
  };

  const baseClasses = 'bg-game-medium/30 border border-game-medium/50 text-gray-300 hover:bg-game-medium/50 hover:text-white hover:border-game-light/50 transition-all duration-200 flex items-center justify-center rounded-lg group disabled:opacity-50 disabled:cursor-not-allowed';
  const sizeClasses = getSizeClasses();
  const finalClassName = `${baseClasses} ${sizeClasses} ${className}`.trim();

  return (
    <button 
      className={finalClassName}
      aria-label="Close"
      title="Close"
      type="button"
      {...props}
    >
      <FaTimes className="text-sm group-hover:scale-110 transition-transform" />
    </button>
  );
};